<template>
    <Form
        style="line-height: 32px"
        :model="formdata"
        :label-width="120"
        inline
        ref="form"
    >
        <FormItem
            :label="
                transfertype == 'batchcancel'
                    ? $t('erp.b2c.cancel_reason', { defaultValue: '取消原因' })
                    : $t('global.common.notes', { defaultValue: '备注' })
            "
            style="width: 90%"
            :rules="required"
            prop="remark"
        >
            <Input v-model="formdata.remark" :rows="3" type="textarea" />
        </FormItem>
        <div class="color-error text-center">
            {{
                $t("erp.b2c.connected_to_erp_system", {
                    defaultValue:
                        "已配货状态取消订单会向erp系统对接的仓库请求取消，erp系统没有对接的仓库无法保证成功取消。",
                })
            }}
        </div>
        <footer class="text-right">
            <Button type="primary" @click="submit">{{
                $t("global.common.save", { defaultValue: "保存" })
            }}</Button>
            <Button class="margin-left-10" @click="cancel">{{
                $t("global.common.cancel", { defaultValue: "取消" })
            }}</Button>
        </footer>
        <Spin size="large" fix v-if="loading"></Spin>
    </Form>
</template>
<script>
import { HttpAddRemark, HttpbatchCancel } from "@/service/boss/b2corder";
export default {
    props: ["activeids", "transfertype"],
    data() {
        return {
            loading: false,
            formdata: {
                remark: "",
            },
            required: [
                {
                    required: true,
                    message: this.$t("global.common.fill_requiredd", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
            ],
        };
    },
    methods: {
        cancel() {
            this.$emit("on-close");
        },
        async submit() {
            let data = await this.$refs["form"].validate();
            if (!data) return;
            this.loading = true;
            if (this.transfertype == "batchcancel") {
                HttpbatchCancel({
                    orderIds: this.activeids,
                    remark: this.formdata.remark,
                })
                    .then(
                        (res) => {
                            this.$Message.success(res.message);
                            this.cancel();
                            this.$emit("on-update");
                        },
                        (err) => {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true,
                            });
                        }
                    )
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                HttpAddRemark({
                    orderIds: this.activeids,
                    remark: this.formdata.remark,
                })
                    .then(
                        (res) => {
                            this.$Message.success(res.message);
                            this.cancel();
                            this.$emit("on-update");
                        },
                        (err) => {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true,
                            });
                        }
                    )
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    },
};
</script>
